import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";
import * as IoIcons from "react-icons/io";
import Slidemenu from "./Slidemenu";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../features/auth/userSlice";
import Logo from "components/common/Logo";

/* ─── Top Navbar ─────────────────────────────────────────────── */
const Navbar = styled.div`
  position: relative;
  background: #0f172a;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  z-index: 11;

  a {
    color: #e2e8f0 !important;
    text-decoration: none;
  }
`;

const HamburgerBtn = styled.button`
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 6px;
  transition: background 150ms ease, color 150ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #f1f5f9;
  }
`;

const UserBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #94a3b8;

  b {
    color: #e2e8f0;
    font-weight: 600;
  }
`;

const LogoutBtn = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #94a3b8;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #f1f5f9;
    border-color: rgba(255, 255, 255, 0.25);
  }
`;

/* ─── Sidebar Drawer ─────────────────────────────────────────── */
const SidebarDrawer = styled.nav`
  background: #0f172a;
  width: 256px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: left 280ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 52px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
`;

const SidebarTitle = styled.span`
  color: #f1f5f9;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #64748b;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  transition: background 150ms ease, color 150ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #e2e8f0;
  }
`;

const MenuScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }
`;

const Overlay = styled.div`
  display: ${({ sidebar }) => (sidebar ? "block" : "none")};
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 99;
  backdrop-filter: blur(1px);
`;

/* ─── Component ──────────────────────────────────────────────── */
function Slidebar() {
  const [sidebar, setSidebar] = useState(false);
  const { user, isAuthenticated } = useSelector((state) => state?.user);
  const dispatch = useDispatch();

  const [SlidebarData, setSlidebarData] = useState([
    { title: "Dashboard", path: "/", icon: <AiIcons.AiFillHome /> },
    { title: "Job Card", path: "/jobcard", icon: <AiIcons.AiFillHome /> },
    { title: "Cloth Inventory", path: "/inventory", icon: <MdIcons.MdOutlineInventory2 /> },
    { title: "Material Inventory", path: "/material", icon: <IoIcons.IoIosPaper /> },
    { title: "Cap Style", path: "/caps", icon: <IoIcons.IoIosPaper /> },
    { title: "Machine", path: "/machine", icon: <FaIcons.FaCogs /> },
    { title: "Reports", path: "/reports", icon: <FaIcons.FaClipboardList /> },
    { title: "Created Cap", path: "/createdcap", icon: <FaIcons.FaCartPlus /> },
    { title: "Inventory Report", path: "/invenreport", icon: <FaIcons.FaCartPlus /> },
  ]);

  useEffect(() => {
    const userx = JSON.parse(localStorage.getItem("user"));

    if (userx && userx?.roll) {
      const role = userx.roll;

      if (role === "degitizer" || role === "sampling_digitizer") {
        setSlidebarData([]);
        return;
      }

      const invReportsSubnav = {
        title: "Inventory Reports",
        path: "/inventory-reports/stock-summary",
        icon: <FaIcons.FaChartBar />,
        iconopened: <FaIcons.FaChevronUp />,
        iconclosed: <FaIcons.FaChevronDown />,
        subnav: [
          { title: "Stock Summary", path: "/inventory-reports/stock-summary", icon: <FaIcons.FaBoxes /> },
          { title: "Stock Summary (Date)", path: "/inventory-reports/stock-summary-datewise", icon: <FaIcons.FaCalendarAlt /> },
          { title: "Usage Datewise", path: "/inventory-reports/usage-datewise", icon: <FaIcons.FaFireAlt /> },
          { title: "Low Stock Alert", path: "/inventory-reports/low-stock", icon: <FaIcons.FaExclamationTriangle /> },
          { title: "Procurement", path: "/inventory-reports/procurement", icon: <FaIcons.FaShoppingCart /> },
          { title: "Manufacturing Usage", path: "/inventory-reports/manufacturing-usage", icon: <FaIcons.FaCogs /> },
          { title: "Procurement Audit", path: "/inventory-reports/procurement-audit", icon: <FaIcons.FaFileAlt /> },
          { title: "Valuation", path: "/inventory-reports/valuation", icon: <FaIcons.FaMoneyBillWave /> },
        ],
      };

      if (role === "store") {
        setSlidebarData([
          { title: "Cloth Inventory", path: "/inventory", icon: <MdIcons.MdOutlineInventory2 /> },
          { title: "Material Inventory", path: "/material", icon: <IoIcons.IoIosPaper /> },
          { title: "Cap Style", path: "/caps", icon: <IoIcons.IoIosPaper /> },
          { title: "Created Cap", path: "/createdcap", icon: <FaIcons.FaCartPlus /> },
          { title: "Inventory Report", path: "/invenreport", icon: <FaIcons.FaChartBar /> },
          invReportsSubnav,
        ]);
        return;
      }

      if (role === "admin" || role === "viewer") {
        setSlidebarData([
          { title: "Dashboard", path: "/", icon: <AiIcons.AiFillHome /> },
          { title: "Job Card", path: "/jobcard", icon: <AiIcons.AiFillHome /> },
          { title: "Cloth Inventory", path: "/inventory", icon: <MdIcons.MdOutlineInventory2 /> },
          { title: "Material Inventory", path: "/material", icon: <IoIcons.IoIosPaper /> },
          { title: "Cap Style", path: "/caps", icon: <IoIcons.IoIosPaper /> },
          { title: "Machine", path: "/machine", icon: <FaIcons.FaCogs /> },
          { title: "Reports", path: "/reports", icon: <FaIcons.FaClipboardList /> },
          { title: "Created Cap", path: "/createdcap", icon: <FaIcons.FaCartPlus /> },
          { title: "Inventory Report", path: "/invenreport", icon: <FaIcons.FaChartBar /> },
          invReportsSubnav,
        ]);
      } else {
        setSlidebarData([
          { title: "Job Card", path: "/jobcard", icon: <AiIcons.AiFillHome /> },
          { title: "Reports", path: "/reports", icon: <FaIcons.FaClipboardList /> },
        ]);
      }
    } else {
      setSlidebarData([
        { title: "Job Card", path: "/jobcard", icon: <AiIcons.AiFillHome /> },
      ]);
    }
  }, [localStorage.getItem("user")]);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (event.target.closest("#slidebar") || event.target.closest("#navbar")) return;
      setSidebar(false);
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const showSidebar = () => setSidebar((s) => !s);
  const closeSidebar = () => setSidebar(false);

  const routePath = typeof window !== "undefined" ? window.location.pathname : "";
  const role = (user && (user.roll || user.role)) || (JSON.parse(localStorage.getItem("user") || "{}").roll);
  const isDigitizerJobcardDetail = /^\/digitizer-jobcards\/[\w-]+$/.test(routePath);
  const disableHamburger =
    role === "degitizer" ||
    role === "sampling_digitizer" ||
    (routePath === "/digitizer-jobcards" && role === "designer") ||
    isDigitizerJobcardDetail;

  return (
    <>
      {/* Top Navbar */}
      <Navbar id="navbar">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {isAuthenticated && !disableHamburger ? (
            <HamburgerBtn onClick={showSidebar} aria-label="Open menu">
              <FaIcons.FaBars />
            </HamburgerBtn>
          ) : null}
          <Logo />
        </div>

        {user ? (
          <UserBar>
            <span>
              Logged in as <b>{user.user}</b>
            </span>
            <LogoutBtn onClick={() => dispatch(logout())}>Logout</LogoutBtn>
          </UserBar>
        ) : (
          <Link to="/login" style={{ fontSize: 13, color: "#94a3b8" }}>
            Login
          </Link>
        )}
      </Navbar>

      {/* Overlay */}
      <Overlay sidebar={sidebar} onClick={closeSidebar} />

      {/* Sidebar Drawer */}
      <SidebarDrawer id="slidebar" sidebar={sidebar}>
        <SidebarHeader>
          <SidebarTitle>Menu</SidebarTitle>
          <CloseBtn onClick={closeSidebar} aria-label="Close menu">
            <AiIcons.AiOutlineClose />
          </CloseBtn>
        </SidebarHeader>

        <MenuScroll>
          {SlidebarData.map((item, index) => (
            <Slidemenu item={item} key={index} onClick={closeSidebar} />
          ))}
        </MenuScroll>
      </SidebarDrawer>
    </>
  );
}

export default Slidebar;